var _rect, _circle, _circle2, _ellipse, _rect2, _path, _path2, _circle3, _circle4, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortraitPro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 600,
    viewBox: "0 0 400 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 600,
    fill: "#190A4E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 180,
    fill: "#2D1B69",
    opacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 140,
    fill: "#3D2B79",
    opacity: 0.3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 220,
    rx: 70,
    ry: 85,
    fill: "#FFB02E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 290,
    width: 40,
    height: 50,
    fill: "#FFB02E",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 340 Q200 360 280 340 L280 400 Q200 390 120 400 Z",
    fill: "#FFB02E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130 180 Q200 140 270 180 L270 220 Q200 200 130 220 Z",
    fill: "#E09920"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 150,
    r: 40,
    fill: "#FFFFFF",
    opacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 180,
    r: 30,
    fill: "#FFFFFF",
    opacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(320, 480)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -15,
    width: 50,
    height: 30,
    rx: 5,
    fill: "#00D9FF",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 12,
    stroke: "#00D9FF",
    strokeWidth: 3,
    fill: "none",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -10,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#00D9FF",
    opacity: 0.6
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 550,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "PORTRAIT")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortraitPro);
export default __webpack_public_path__ + "static/media/portrait-pro.c829b45a8fd4f4cf908f72bc02526f3d.svg";
export { ForwardRef as ReactComponent };